import { TransformToGlobalPayload } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const transformToGlobal = actionCreator<TransformToGlobalPayload>(
  '[DOCUMENT_ARCHIVE] TRANSFORM TO GLOBAL'
);

export const scrollAndHighlightRow = actionCreator<string>(
  '[DOCUMENT_ARCHIVE] SCROLL AND HIGHLIGHT ROW'
);
